/**
 * signalR properties
 */
export const SIGNAL_R_PROPERTIES = {
  trainCardsHub: 'staff-app-train-cards-hub',
  trainCardsMethod: 'trains',
};
